import { MsalProvider } from "@azure/msal-react";
import { ConfigProvider } from "antd";
import { isDevelopment, printAppVersion } from "core/utils";
import { StrictMode, useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { ErrorPage } from "src/app/pages/ErrorPage/ErrorPage";
import { initTranslations } from "src/translations";
import { AppRouter } from "./core/router/components/AppRouter";
import { msalInstance } from "./core/router/config/msalConfig";
import { useAppRouterConfig } from "./core/router/hooks/useAppRouterConfig";
import { store } from "./core/setup/redux";
import { persistor } from "./core/setup/redux/store";
import { Palette } from "./core/styles/palette";

export const AppEntry = () => {
    // eslint-disable-next-line no-underscore-dangle
    const isMSEntraLogin = window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra";
    const apaRouterConfig = useAppRouterConfig();
    useEffect(() => {
        initTranslations();
    }, []);

    if (isDevelopment()) {
        printAppVersion();
    }

    return (
        <StrictMode>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: Palette.HeroGreen,
                    },
                }}
            >
                <ErrorBoundary FallbackComponent={ErrorPage}>
                    <Provider store={store}>
                        <PersistGate loading={null} persistor={persistor}>
                            {isMSEntraLogin ? (
                                <MsalProvider instance={msalInstance}>
                                    <AppRouter router={apaRouterConfig} />
                                </MsalProvider>
                            ) : (
                                <AppRouter router={apaRouterConfig} />
                            )}
                        </PersistGate>
                    </Provider>
                </ErrorBoundary>
            </ConfigProvider>
        </StrictMode>
    );
};
